import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Breadcrumbs({ items }) {
    return (
        <nav className="text-xs text-ink-muted py-3" aria-label="Breadcrumb" data-testid="breadcrumbs">
            <ol className="flex items-center gap-1.5 flex-wrap">
                {items.map((it, i) => (
                    <li key={i} className="flex items-center gap-1.5">
                        {i > 0 && <ChevronRight size={11} className="text-ink-muted" />}
                        {it.href && i < items.length - 1 ? (
                            <Link to={it.href} className="hover:text-cobalt ui-heading uppercase tracking-widest">{it.label}</Link>
                        ) : (
                            <span className="ui-heading uppercase tracking-widest text-ink">{it.label}</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
